module.exports = __webpack_public_path__ + "img/habitation-bien-isole.77cfd01b.svg";